import { FormatNumberWithCommas } from "../../../../../../shared/scripts/number-functions";
import { SetActiveTab } from "../../../../../../shared/scripts/tab-utilities";
import { RenderNullableNumberWithSeparators, RenderProgressValue } from "../../../../../../shared/scripts/table-functions";
import { InterventionsDialog } from "../scripts/interventions.dialog";
import { InterventionsLookup } from "../scripts/interventions.lookup";
import { InterventionsDatatableEntry } from "./interventions-datatable-entities";

export class InterventionsDatatableView {

    selectedGrouping: string; // none, by site

    tableNone: any; tableNoneId: string = "interventions-datatable-none";
    tableBySite: any; tableBySiteId: string = "interventions-datatable-bysite";

    currentTableEntriesNone: InterventionsDatatableEntry[] = [];
    currentTableEntriesBySite: InterventionsDatatableEntry[] = [];

    constructor() {
        this.selectedGrouping = "none";

        this.tableNone = this.initializeTable(this.tableNoneId);
        this.tableBySite = this.initializeTable(this.tableBySiteId);

        this.initializeDialog([this.tableNoneId, this.tableBySiteId]);

        this.setupCsvExportButton();
    }

    private setupCsvExportButton(): void {
        const exportButton = document.getElementById("export-csv-btn-intervention");

        if (exportButton) {
            exportButton.addEventListener("click", () => {
                this.exportCsv();
            });
        }
    }

    private exportCsv(): void {
        if (this.selectedGrouping === "none") {
            this.tableNone.button('.buttons-csv').trigger();
        } else if (this.selectedGrouping === "bysite") {
            this.tableBySite.button('.buttons-csv').trigger();
        }
    }

    SetView(newView: string): void {
        if (!newView.startsWith("interventions-datatable")) { return; }

        if (newView.includes("none")) { this.selectedGrouping = "none"; }
        if (newView.includes("bysite")) { this.selectedGrouping = "bysite"; }

        if (this.selectedGrouping == "none") { SetActiveTab("interventions-datatable-tabs", "content-interventions-datatable-none"); this.tableNone.columns.adjust().draw(false); }
        else if (this.selectedGrouping == "bysite") { SetActiveTab("interventions-datatable-tabs", "content-interventions-datatable-bysite"); this.tableBySite.columns.adjust().draw(false); }

        this.UpdateData(this.currentTableEntriesNone, this.currentTableEntriesBySite);
    }

    UpdateData(noneEntries: InterventionsDatatableEntry[], bySiteEntries: InterventionsDatatableEntry[]): void {

        $('.discon-reason-count-button').removeClass('hide-arrow').addClass('show-arrow');
        $('.discon-reason-count').addClass('hidden');

        $('.dnc-reason-count-button').removeClass('hide-arrow').addClass('show-arrow');
        $('.dnc-reason-count').addClass('hidden');

        this.currentTableEntriesNone = noneEntries;
        this.currentTableEntriesBySite = bySiteEntries;

        if ($(`#${this.tableNoneId}`).is(":visible")) {
            this.tableNone.clear();
            this.tableNone.rows.add(this.currentTableEntriesNone).draw();
        }

        if ($(`#${this.tableBySiteId}`).is(":visible")) {
            this.tableBySite.clear();
            this.tableBySite.rows.add(this.currentTableEntriesBySite).draw();
        }


        $('.discon-reason-count-button').off("click");
        $('.dnc-reason-count-button').off("click");

        $('.discon-reason-count-button').on("click", (e) => {
            if ($(e.target).hasClass('show-arrow')) {
                $(e.target).removeClass('show-arrow').addClass('hide-arrow');
                $('.discon-reason-count').removeClass('hidden');
                $('.discprior-expand').removeClass('gray');
                $('.discprior-expand').addClass('med-blue-col-header');
            } else if ($(e.target).hasClass('hide-arrow')) {
                $(e.target).removeClass('hide-arrow').addClass('show-arrow');
                $('.discon-reason-count').addClass('hidden');
                $('.discprior-expand').addClass('gray');
                $('.discprior-expand').removeClass('med-blue-col-header');
            }
        });
        $('.dnc-reason-count-button').on("click", (e) => {
            if ($(e.target).hasClass('show-arrow')) {
                $(e.target).removeClass('show-arrow').addClass('hide-arrow');
                $('.dnc-reason-count').removeClass('hidden');
                $('.dnc-expand').removeClass('gray');
                $('.dnc-expand').addClass('med-blue-col-header');
            } else if ($(e.target).hasClass('hide-arrow')) {
                $(e.target).removeClass('hide-arrow').addClass('show-arrow');
                $('.dnc-reason-count').addClass('hidden');
                $('.dnc-expand').addClass('gray');
                $('.dnc-expand').removeClass('med-blue-col-header');
            }
        });
    }

    private initializeTable(tableId: string): any {

        let dataTable: any = $('#' + tableId).DataTable({
            "dom": 'lrtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '70vh',
            //scroller: {
            //    loadingIndicator: true,
            //    displayBuffer: 10,
            //},
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 4
            },
            columns: [
                //{ data: "Study", title: "Study", className: "text-left font-size12 nowrap" },
                { data: "Appendix", title: "Trial", className: "text-left font-size12 nowrap" },
                { data: "SiteNumber", title: "Site", className: "text-left font-size12 nowrap" },
                { data: "Site", title: "Site Name", className: "text-left font-size12" },
                //{ data: "Consented", title: "Consented<br>Participants", className: "text-center font-size12 nowrap"},
                { data: "PotentialInterventions", title: "Potential<br>Interventions", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators },
                { data: "ExpectedInterventions", title: "Expected<br>Interventions", className: "text-center font-size12 nowrap", render: RenderNullableNumberWithSeparators },
                { data: "Completed.1", title: "Percent<br>Completed<br>(Full Course)", className: "text-center font-size12 nowrap gray font-underline clickable-completed", render: RenderProgressValue, defaultContent: '' },
                { data: "Partial.1", title: "<div class='row int-expandable'><div class='col-8'>Percent<br>Completed<br>(Incomplete<br>dose(s) or<br>session(s))</div><div class='col-2 arrow-col'><span class='dnc-reason-count-button show-arrow'></span></div></div>", className: "text-center font-size12 nowrap gray font-underline clickable-partial dnc-expand", render: RenderProgressValue, defaultContent: '' },
                { data: "DNCReasonCounts.17", title: InterventionsLookup.GetDncInterventionReasonForTable(17), className: "dnc-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                { data: "DNCReasonCounts.16", title: InterventionsLookup.GetDncInterventionReasonForTable(16), className: "dnc-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                { data: "DNCReasonCounts.8", title: InterventionsLookup.GetDncInterventionReasonForTable(8), className: "dnc-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                { data: "DNCReasonCounts.12", title: InterventionsLookup.GetDncInterventionReasonForTable(12), className: "dnc-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                { data: "DNCReasonCounts.13", title: InterventionsLookup.GetDncInterventionReasonForTable(13), className: "dnc-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                { data: "Ongoing.1", title: "Percent<br>Ongoing", className: "text-center font-size12 nowrap gray font-underline clickable-ongoing", render: RenderProgressValue, defaultContent: '' },
                { data: "DiscPrior.1", title: "<div class='row int-expandable'><div class='col-8'>Percent<br>Disc. Early</div><div class='col-2 arrow-col'><span class='discon-reason-count-button show-arrow'></span></div></div>", className: "text-center font-size12 nowrap gray font-underline clickable-discprior discprior-expand", render: RenderProgressValue, defaultContent: '' },
/*                { title: '<span class="discon-reason-count-button show-arrow"></span>', className: "text-center font-size12 nowrap gray font-underline discprior-expand", defaultContent: ''},*/
                { data: "DisconReasonCounts.1", title: InterventionsLookup.GetDisconReasonFormattedForTable(1),   className: "discon-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                { data: "DisconReasonCounts.2", title: InterventionsLookup.GetDisconReasonFormattedForTable(2),   className: "discon-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                { data: "DisconReasonCounts.3",  title: InterventionsLookup.GetDisconReasonFormattedForTable(3),  className: "discon-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                { data: "DisconReasonCounts.4",  title: InterventionsLookup.GetDisconReasonFormattedForTable(4),  className: "discon-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                { data: "DisconReasonCounts.12", title: InterventionsLookup.GetDisconReasonFormattedForTable(12), className: "discon-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                { data: "DisconReasonCounts.7", title: InterventionsLookup.GetDisconReasonFormattedForTable(7),   className: "discon-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                { data: "DisconReasonCounts.10", title: InterventionsLookup.GetDisconReasonFormattedForTable(10), className: "discon-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                { data: "DisconReasonCounts.11", title: InterventionsLookup.GetDisconReasonFormattedForTable(11), className: "discon-reason-count text-center font-size12 nowrap hidden light-blue-col-header" },
                //{ data: "DisconReasonCounts.12", title: InterventionsLookup.GetDisconReasonFormattedForTable(12), className: "discon-reason-count text-center font-size12 nowrap hidden" },
                { data: "NotDone.1", title: "Percent<br>Never Started", className: "text-center font-size12 nowrap gray font-underline clickable-notdone", render: RenderProgressValue, defaultContent: '' },
            ],
            buttons: [
                {
                    extend: 'csv',
                    className: "btn btn-secondary",
                    text: '<i class="fas fa-file-download"></i>',
                    charset: 'utf-8',
                    title: "RECOVER-CT Interventions Export",
                }
            ],
            createdRow: (row, data: any, index) => {
                //cell formatting on percentages
                if (data.Completed[1] != undefined) { this.setCellPercentValue(row, 'td:eq(5)', this.getCellColorByValue("Completed", data.Completed[1]), data.Completed[0]); }
                if (data.Partial[1] != undefined) { this.setCellPercentValue(row, 'td:eq(6)', this.getCellColorByValue("Partial", data.Partial[1]), data.Partial[0]); }
                if (data.Ongoing[1] != undefined) { this.setCellPercentValue(row, 'td:eq(12)', this.getCellColorByValue("Ongoing", data.Ongoing[1]), data.Ongoing[0]); }
                if (data.DiscPrior[1] != undefined) { this.setCellPercentValue(row, 'td:eq(13)', this.getCellColorByValue("DiscPrior", data.DiscPrior[1]), data.DiscPrior[0]); }
                if (data.NotDone[1] != undefined) { this.setCellPercentValue(row, 'td:eq(22)', this.getCellColorByValue("NotDone", data.NotDone[1]), data.NotDone[0]); }

            }
        });

        dataTable.on('column-visibility.dt', function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
        $('[data-toggle="tooltip"]').tooltip()


        return dataTable;
    }

    private getCellColorByValue(dataElement: string, value: number): string {
        if (dataElement == "Completed" || dataElement == "Partial") {
            if (value >= 0.85) return "#7fb87f";
            else if (value >= 0.65) return "#FCE77D";
            else return "#F07D7D";
        }
        else if (dataElement == "Ongoing" || dataElement == "NotDone") {
            if (value < 0.10) return "#7fb87f";
            else if (value <= 0.20) return "#FCE77D";
            else return "#F07D7D";
        }
        else if (dataElement == "DiscPrior") {
            if (value < 0.10) return "#7fb87f";
            else if (value <= 0.20) return "#FCE77D";
            else return "#F07D7D";
        }
    }

    private setCellPercentValue(row: any, cell: string, color: string, count: number): void {
        $(cell, row).css('background-color', color);
        $(cell, row).attr('title', 'n = ' + count);
        $(cell, row).attr('data-toggle', 'tooltip');
        $(cell, row).attr('data-placement', 'top');
    }

    private initializeDialog(tableIds: string[]): void {
        tableIds.forEach(tableId => {
            $('#' + tableId).on('click', 'td.clickable-completed', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                InterventionsDialog.ShowDialog(row.CompletedInterventions);
            });
            $('#' + tableId).on('click', 'td.clickable-partial', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                InterventionsDialog.ShowDialog(row.PartialInterventions);
            });
            $('#' + tableId).on('click', 'td.clickable-ongoing', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                InterventionsDialog.ShowDialog(row.OngoingInterventions);
            });
            $('#' + tableId).on('click', 'td.clickable-notdone', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                InterventionsDialog.ShowDialog(row.NotDoneInterventions);
            });
            $('#' + tableId).on('click', 'td.clickable-discprior', function () {
                var row = $('#' + tableId).DataTable().row(this).data();
                InterventionsDialog.ShowDialog(row.DiscPriorInterventions);
            });
        });
    }

}